import { useMemo } from 'react';

import { eocUserResource } from '@atlassian/eoc-resources';
import { useResource } from '@atlassian/eoc-rrr-helpers';

import { heartbeatsResource } from '../../services/resources';
import { useHeartbeatsContext } from '../providers/heartbeats';

export const useListController = () => {
	const { filters } = useHeartbeatsContext();

	const { data } = useResource(heartbeatsResource);
	const { data: user } = useResource(eocUserResource);

	const timezone = useMemo(
		() => user?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
		[user?.timeZone],
	);

	const heartbeats = useMemo(() => {
		let list = data?.heartbeats || [];

		if (filters.searchText) {
			const searchValue = filters.searchText.toLowerCase();

			list = list.filter((item) => item.name.toLowerCase().includes(searchValue));
		}

		if (filters.statuses.length) {
			list = list.filter((item) => filters.statuses.some((option) => option.value === item.status));
		}

		return list;
	}, [data, filters]);

	return {
		timezone,
		heartbeats,
	};
};
